<ion-grid>
    <ion-row>
        <ion-col style="display: flex;">

            <ng-container *ngIf="FormControl">

                <ion-input type="text" placeholder="Escolher ficheiro" readonly [value]="FormControl?.value?.name||FormControl?.value?.OriginalName"
                    [disabled]="FormControl.disabled"
                    [ngClass]="{ 'ng-invalid': !FormControl.valid && FormControl.touched, 'ng-touched': FormControl.touched }"></ion-input>

            </ng-container>

            <ng-container *ngIf="!FormControl">

                <ion-input type="text" [value]="Filename||''" readonly></ion-input>

            </ng-container>

            <input #file hidden type="file" (change)="OnFileChange($event)" [accept]="accept" />

            <ion-button *ngIf="FileURL" fill="clear" size="small" color="medium" class="ion-margin-start"
                (click)="OnViewFile($event)">
                <ion-icon slot="icon-only" name="open-outline"></ion-icon>
            </ion-button>

            <ion-button *ngIf="onDelete" fill="clear" size="small" color="medium" class="ion-margin-start"
                [disabled]="Disabled" (click)="OnDelete($event)">
                <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
            </ion-button>

        </ion-col>

        <ion-col *ngIf="!Disabled && !onDelete" style="max-width: 155px; text-align: right;">
            <ion-button color="medium" (click)="file?.click()">{{buttonName}}</ion-button>
        </ion-col>

    </ion-row>
    <ion-row *ngIf="TemplateFile">
        <ion-col>
            <a class="file-template" [href]="TemplateFile" download>ficheiro template</a>
        </ion-col>
    </ion-row>
</ion-grid>
<!-- <span class="fix-filename">{{Filename||''}}</span> -->